import { AlertCircle } from "lucide-react";
import "../../../../assets/css/global.css";
import { useNavigate } from "react-router-dom";

import TranslatorService from "../../../../services/Translator/TranslatorService";

import MainContainer from "../../../Organisms/MainContainer";
import BreadCrumb from "../../../Molecules/BreadCrumb";
import ItemList from "../../../Atoms/ItemList";
import CustomParagraph from "../../../Atoms/CustomParagraph";
import Button from "../../../Atoms/Button";
import SimpleContainer from "../../../Organisms/SimpleContainer";
import TitleSection from "../../../Molecules/TitleSection";
import TitleH1 from "../../../Atoms/TitleH1";

const NaoEncontradoTemplate = () => {
  const navigate = useNavigate();

  const backUserToHome = () => {
    navigate("/");
  };

  return (
    <MainContainer className="main overflow-auto">
      <BreadCrumb className="breadcrumb d-flex align-items-center flex-sh-0">
        <ItemList linkTo="/">
          <AlertCircle />
          &ensp;
          <TranslatorService path="chatNotFound.mainTitle" />
        </ItemList>
      </BreadCrumb>
      <SimpleContainer>
        <TitleSection>
          <TitleH1>
            Chat não encontrado!
          </TitleH1>
          <CustomParagraph>
            <TranslatorService path="chatNotFound.message" />
          </CustomParagraph>
          <Button className="btn btn-primary" onClick={() => backUserToHome()}>
            <TranslatorService path="chatNotFound.buttonMessage" />
          </Button>
        </TitleSection>
      </SimpleContainer>
    </MainContainer>
  );
};

export default NaoEncontradoTemplate;
